import {gsap} from "gsap";
import AnimationChars from "../../animation/chars/chars";
import AnimationFade from "../../animation/fade/fade";
import services from "../../../libs/services";
import threeSketch from "../../../libs/three-sketch";
import * as THREE from "three";
import f from "./f.glsl";
import v from "./v.glsl";
import {imgSrcOriginal, ThreeJsGetX, ThreeJsGetY} from "../../../libs/helper";
import EmitEvent, {HT_RESIZE, OBSERVER_HEIGHT_CHANGED, PAGE_LOADED} from "../../../libs/emit-event";

export class FeatureTeamItem {
    constructor({el, uniforms, addGroup}) {

        this.DOM = {el};

        this.uniforms = {
            ...uniforms, ...{
                u_texture: {value: null},
                u_size: {value: new THREE.Vector2()},
                u_radius: {value: .009},
                u_posY: {value: 1}
            }
        };
        this.zIndex = 0;
        this.prop = {};
        this.addGroup = addGroup;
        this.DOM.image = this.DOM.el.querySelector('.js-webgl-team--image');

        this.pageLoaded = this.pageLoaded.bind(this);
        this.handleScrolling = this.handleScrolling.bind(this);
        this.pageResize = this.pageResize.bind(this);

        this.init();
        this.bindEvent();
    }

    init() {
        this.aniamtions = {
            name: new AnimationChars(this.DOM.el.querySelector('.js-featureTeamsItem_name'), {
                type: "2d",
                _to: {
                    duration: .6
                }
            }),
            position: new AnimationFade(this.DOM.el.querySelector('.js-featureTeamsItem_position'))
        };
        const image = this.DOM.el.querySelector('img');
        const src = imgSrcOriginal(image);
        threeSketch.loadTexture({src}).then(this.initTexture.bind(this));
        this.DOM.image.style.visibility = 'hidden';
        this.DOM.el.style.pointerEvents = 'none';
    }

    animationIn(up = true) {
        this.DOM.el.style.pointerEvents = 'auto';
        if (up) {
            this.aniamtions.name.options._from.y = `120%`;
        } else {
            this.aniamtions.name.options._from.y = `-120%`;
        }
        this.aniamtions.name.animationIn();
        this.aniamtions.position.animationIn();
        gsap.to(this.uniforms.u_posY, {value: 0, ease: 'power3.inOut', duration: .8});
    }

    textAnimationOut() {
        this.aniamtions.position.animationOut();
        this.DOM.el.style.pointerEvents = 'none';
    }

    animationTop() {
        gsap.to(this.uniforms.u_posY, {value: -1, ease: 'power3.inOut', duration: .8});
        this.aniamtions.name.animationOutTop();
        this.textAnimationOut();
    }

    animationBottom() {
        gsap.to(this.uniforms.u_posY, {value: 1, ease: 'power3.inOut', duration: .8});
        this.aniamtions.name.animationOutBottom();
        this.textAnimationOut();
    }

    getProp() {
        const scrollTop = Math.abs(services.smooth_scrolling_instance);
        const {top, width, height, left} = this.DOM.image.getBoundingClientRect();
        this.prop.top = top + scrollTop;
        this.prop.live = top;
        this.prop.left = left;
        this.prop.width = width;
        this.prop.height = height;
    }

    initTexture(texture) {
        this.getProp();


        this.uniforms.u_texture.value = texture;
        // this.uniforms.u_texture.value.magFilter = THREE.NearestFilter;
        this.uniforms.u_texture.value.minFilter = THREE.LinearFilter;

        const geo = new THREE.PlaneBufferGeometry(1, 1, 20, 20);
        const mat = new THREE.ShaderMaterial({
            uniforms: this.uniforms,
            fragmentShader: f,
            vertexShader: v,
            transparent: true
        });

        this.mesh = new THREE.Mesh(geo, mat);
        this.addGroup(this.mesh);
        this.setSize();
    }

    setSize() {
        if (this.mesh) {
            this.mesh.scale.set(this.prop.width, this.prop.height, 1);
            this.mesh.position.set(ThreeJsGetX(this.prop.left, this.prop.width), ThreeJsGetY(this.prop.live, this.prop.height), this.zIndex * .1);
        }
    }

    pageLoaded() {
        this.getProp();
        this.setSize();
    }

    handleScrolling(disTran) {
        if (this.mesh) {
            this.mesh.position.y = ThreeJsGetY(disTran, this.prop.height);
        }
    }

    pageResize() {
        this.uniforms.u_res.value = new THREE.Vector2(services.winSize.width, services.winSize.height);
        this.getProp();
        this.setSize();
    }

    bindEvent() {
        EmitEvent.on(OBSERVER_HEIGHT_CHANGED, this.pageResize);
        EmitEvent.on(HT_RESIZE, this.pageResize);
        EmitEvent.on(PAGE_LOADED, this.pageLoaded);
    }

    removeEvent() {
        EmitEvent.off(HT_RESIZE, this.pageResize);
        EmitEvent.off(OBSERVER_HEIGHT_CHANGED, this.pageResize);
        EmitEvent.off(PAGE_LOADED, this.pageLoaded);
    }
}